// import defaultIcon from "@/static/images/notify-icon.png";
// let isNotificationListenerBound = false;
export type NotificationOption = {
  id?: string;
  title: string;
  message: string;
  iconUrl?: string;
  imageUrl?: string;
  action?: {
    type?: "OpenUrl";
    url?: string;
  };
};
// const idActionMap: Record<string, NotificationOption["action"]> = {};

export function notify({
  id,
  title,
  message,
  iconUrl,
  imageUrl,
  action = {},
}: NotificationOption) {
  // if (!isNotificationListenerBound) {
  //   isNotificationListenerBound = true;
  //   // 通知被点击
  //   chrome.notifications.onClicked.addListener((nid) => {
  //     // console.log("onClicked", nid);
  //     const act = idActionMap[nid] || {};
  //     if (act.type === "OpenUrl") {
  //       act.url && chrome.tabs.create({ url: act.url });
  //       // chrome.notifications.clear(nid);
  //     }
  //   });

  //   // // 自动关闭不会触发
  //   // chrome.notifications.onClosed.addListener((nid, byUser) => {
  //   //   console.log("onClosed", nid, byUser);
  //   //   chrome.notifications.onClosed.removeListener();
  //   // });

  //   //   chrome.notifications.onButtonClicked.addListener(
  //   //     (notificationId, buttonIndex) => {
  //   //       console.log(
  //   //         "通知中设置的buttons按钮被点击了",
  //   //         notificationId,
  //   //         buttonIndex
  //   //       );
  //   //       chrome.tabs.create({ url: "https://www.google.com" });
  //   //     }
  //   //   );

  //   // 没效果
  //   //   chrome.notifications.onShowSettings.addListener(() => {
  //   //     console.log("用户点击了通知的设置按钮");
  //   //     // 在这里执行你需要的操作，例如打开设置页面
  //   //     // chrome.runtime.openOptionsPage();
  //   //     chrome.tabs.create({ url: "https://www.163.com" });
  //   //   });
  // }

  let options: chrome.notifications.NotificationOptions = {
    type: "image", //image progress 上不显示 list在mac上只显示一条
    title: title,
    // contextMessage: "显示在title 和 message中间，一行粗体消息，超出会...显示",
    message: message,
    iconUrl: iconUrl, // 方图 最大显示 160 * 160 提供 320 * 320 以适应高分屏

    // type为image时必选
    imageUrl: imageUrl || iconUrl,
    //   priority: 2,
    // requireInteraction: false, //默认 false 使用 Google Chrome通知； 为true 使用 Google Chrome Helper(Alert) 通知 ，与系统设置有关，需不需要手动关闭与系统设置有关
    // 最多2个按钮
    // buttons: [
    //   {
    //     title: "Button Title 1",
    //   },
    //   {
    //     title: "Button Title 2",
    //   },
    // ],
  };

  const createNotificationsPromise = id
    ? chrome.notifications.create(id, options)
    : chrome.notifications.create(options);

  return createNotificationsPromise
    .then((nid) => {
      // console.log("通知:", nid);
      chrome.storage.local.set({
        [`id_act_${nid}`]: action,
      });
      // idActionMap[nid] = action;
      return nid;
    })
    .catch((error) => console.log(error));
}

function cookies2str(cookies: chrome.cookies.Cookie[]) {
  return cookies.map((cookie) => `${cookie.name}=${cookie.value}`).join("; ");
  // let cookiesStr = "";
  // return (
  //   cookies.forEach(function (cookie: any) {
  //     cookie.name &&
  //       cookie.value &&
  //       (cookiesStr += cookie.name + "=" + cookie.value + "; ");
  //   }),
  //   cookiesStr
  // );
}

export function getCookie(url: string, name: string): Promise<string> {
  return chrome.cookies.get({ url, name }).then((cookie) => {
    return cookie?.value?.replace(/"/g, "") || "";
  });
}

export function getCookies(url: string): Promise<string> {
  return chrome.cookies.getAll({ url }).then((cookies) => {
    return cookies2str(cookies);
  });
}

export function getExtensionInfo() {
  return {
    // locale: chrome.i18n?.getUILanguage(),
    // extId: chrome.runtime?.id,
    // version: chrome.runtime?.getManifest().version,
  };
}
